export default __webpack_public_path__ + "static/media/megaphone.32c55b06.svg";